import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"
import { Autoplay, Navigation } from "swiper/modules"

// Booksy reviews strip on the home page: 1 review on phones, 5 on a laptop.
export default class extends Controller {
  static targets = ["swiper", "next", "prev"]

  connect() {
    this.swiper = new Swiper(this.swiperTarget, {
      modules: [Autoplay, Navigation],
      slidesPerView: 1,
      spaceBetween: 16,
      rewind: true,
      autoplay: { delay: 6000, pauseOnMouseEnter: true, disableOnInteraction: false },
      navigation: { nextEl: this.nextTarget, prevEl: this.prevTarget },
      breakpoints: {
        576: { slidesPerView: 2 },
        992: { slidesPerView: 3 },
        1200: { slidesPerView: 5, spaceBetween: 20 }
      }
    })
  }

  disconnect() {
    this.swiper?.destroy(true, true)
  }
}
